$(document).ready(function () {     
  var paramName = "ad";
  var url = window.location.href;
  if (url.indexOf(paramName + "=") >= 0){
    var paramValue = QUERY_STRING(paramName);
    if(paramValue != ""){
      $('body a').each(function () {		
		if (this.href != "" && this.href.indexOf("javascript") < 0 && this.href.indexOf("(") < 0 && this.href != "#" && this.href != undefined && this.href.indexOf("?" + paramName + "=") < 0 && this.href.indexOf("&"+ paramName +"=") < 0) {
  			this.href += (this.href.indexOf("?") < 0) ? "?"+ paramName +"=" + paramValue : "&"+ paramName +"=" + paramValue;
		}		
      });
      storeCurrAd(paramName,paramValue);
    }
  }else{
    var preAdValue = getPreviousAd(paramName);
     if (preAdValue != undefined && preAdValue  != null && preAdValue  != ""){
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.set(paramName, preAdValue);
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString(); 
        window.history.pushState({path: newurl}, '', newurl);    
     }
  }
});


function storeCurrAd(adKey, adValue){ 
  window.localStorage.setItem(adKey,adValue);
}

function getPreviousAd(adKey){
  const pathname = window.localStorage.getItem(adKey);
  return pathname;
}

function QUERY_STRING(key) {
  var val = "";
  query = window.location.search.substring(1);
  pairs = query.split("&");
  for (i = 0; i < pairs.length; i++) {
    pair = pairs[i].split("=");
    if (pair[0] == key) {
      val = decodeURI(pair[1]);
      break;
    }
  }
  return val;
}